var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { defineCustomTags } from "sb-resp-lib";
defineCustomTags("sb-resp-popup-overlay");
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    function Overlay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.html = React.createRef();
        _this.onTouchMove = _this.props.onTouchMove.bind(_this);
        return _this;
    }
    Overlay.prototype.componentDidMount = function () {
        if (this.html.current) {
            this.html.current.addEventListener("touchmove", this.onTouchMove, false);
        }
    };
    Overlay.prototype.componentWillUnmount = function () {
        if (this.html.current) {
            this.html.current.removeEventListener("touchmove", this.onTouchMove, false);
        }
    };
    Overlay.prototype.render = function () {
        return (React.createElement("sb-resp-popup-overlay", { ref: this.html, onClick: this.props.onClick }));
    };
    return Overlay;
}(React.PureComponent));
export { Overlay };
//# sourceMappingURL=Overlay.js.map